import { __decorate } from 'tslib';
import { ReactWrapperComponent, AngularReact, registerElement } from '@angular-react/core';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewChild, Input, Output, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Styled } from '@angular-react/fabric/lib/utils';
import { CommonModule } from '@angular/common';
import { Dialog, DialogContent, DialogFooter } from '@fluentui/react/lib/Dialog';

let FabDialogComponent = class FabDialogComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer);
        this.onDismiss = new EventEmitter();
        this.onDismissHandler = this.onDismissHandler.bind(this);
    }
    onDismissHandler(ev) {
        this.onDismiss.emit(ev && ev.nativeEvent);
    }
};
/** @nocollapse */ FabDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabDialogComponent, selector: "fab-dialog", inputs: { responsiveMode: "responsiveMode", elementToFocusOnDismiss: "elementToFocusOnDismiss", ignoreExternalFocusing: "ignoreExternalFocusing", forceFocusInsideTrap: "forceFocusInsideTrap", firstFocusableSelector: "firstFocusableSelector", closeButtonAriaLabel: "closeButtonAriaLabel", isClickableOutsideFocusTrap: "isClickableOutsideFocusTrap", componentRef: "componentRef", styles: "styles", theme: "theme", dialogContentProps: "dialogContentProps", hidden: "hidden", modalProps: "modalProps", minWidth: "minWidth", maxWidth: "maxWidth" }, outputs: { onDismiss: "onDismiss" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabDialog"], usesInheritance: true, ngImport: i0, template: `
    <!-- prettier-ignore -->
    <Dialog
      #reactNode
      [responsiveMode]="responsiveMode"
      [elementToFocusOnDismiss]="elementToFocusOnDismiss"
      [ignoreExternalFocusing]="ignoreExternalFocusing"
      [forceFocusInsideTrap]="forceFocusInsideTrap"
      [firstFocusableSelector]="firstFocusableSelector"
      [closeButtonAriaLabel]="closeButtonAriaLabel"
      [isClickableOutsideFocusTrap]="isClickableOutsideFocusTrap"
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [dialogContentProps]="dialogContentProps"
      [hidden]="hidden"
      [modalProps]="modalProps"
      [minWidth]="minWidth"
      [maxWidth]="maxWidth"
      (onDismiss)="onDismissHandler($event)"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </Dialog>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabDialogComponent = __decorate([
    AngularReact(),
    Styled('FabDialogComponent')
], FabDialogComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-dialog',
                    exportAs: 'fabDialog',
                    template: `
    <!-- prettier-ignore -->
    <Dialog
      #reactNode
      [responsiveMode]="responsiveMode"
      [elementToFocusOnDismiss]="elementToFocusOnDismiss"
      [ignoreExternalFocusing]="ignoreExternalFocusing"
      [forceFocusInsideTrap]="forceFocusInsideTrap"
      [firstFocusableSelector]="firstFocusableSelector"
      [closeButtonAriaLabel]="closeButtonAriaLabel"
      [isClickableOutsideFocusTrap]="isClickableOutsideFocusTrap"
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [dialogContentProps]="dialogContentProps"
      [hidden]="hidden"
      [modalProps]="modalProps"
      [minWidth]="minWidth"
      [maxWidth]="maxWidth"
      (onDismiss)="onDismissHandler($event)"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </Dialog>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], responsiveMode: [{
                type: Input
            }], elementToFocusOnDismiss: [{
                type: Input
            }], ignoreExternalFocusing: [{
                type: Input
            }], forceFocusInsideTrap: [{
                type: Input
            }], firstFocusableSelector: [{
                type: Input
            }], closeButtonAriaLabel: [{
                type: Input
            }], isClickableOutsideFocusTrap: [{
                type: Input
            }], componentRef: [{
                type: Input
            }], styles: [{
                type: Input
            }], theme: [{
                type: Input
            }], dialogContentProps: [{
                type: Input
            }], hidden: [{
                type: Input
            }], modalProps: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], onDismiss: [{
                type: Output
            }] } });
let FabDialogFooterComponent = class FabDialogFooterComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer);
    }
};
/** @nocollapse */ FabDialogFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogFooterComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabDialogFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabDialogFooterComponent, selector: "fab-dialog-footer", inputs: { componentRef: "componentRef", styles: "styles", theme: "theme", className: "className" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabDialogFooter"], usesInheritance: true, ngImport: i0, template: `
    <DialogFooter #reactNode [componentRef]="componentRef" [styles]="styles" [theme]="theme" [className]="className">
      <ReactContent><ng-content></ng-content></ReactContent>
    </DialogFooter>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabDialogFooterComponent = __decorate([
    AngularReact(),
    Styled('FabDialogFooterComponent')
], FabDialogFooterComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-dialog-footer',
                    exportAs: 'fabDialogFooter',
                    template: `
    <DialogFooter #reactNode [componentRef]="componentRef" [styles]="styles" [theme]="theme" [className]="className">
      <ReactContent><ng-content></ng-content></ReactContent>
    </DialogFooter>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], componentRef: [{
                type: Input
            }], styles: [{
                type: Input
            }], theme: [{
                type: Input
            }], className: [{
                type: Input
            }] } });
let FabDialogContentComponent = class FabDialogContentComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer);
        this.onDismiss = new EventEmitter();
    }
};
/** @nocollapse */ FabDialogContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogContentComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabDialogContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabDialogContentComponent, selector: "fab-dialog-content", inputs: { componentRef: "componentRef", styles: "styles", theme: "theme", isMultiline: "isMultiline", showCloseButton: "showCloseButton", topButtonsProps: "topButtonsProps", className: "className", subTextId: "subTextId", subText: "subText", titleId: "titleId", title: "title", responsiveMode: "responsiveMode", closeButtonAriaLabel: "closeButtonAriaLabel", type: "type", draggableHeaderClassName: "draggableHeaderClassName" }, outputs: { onDismiss: "onDismiss" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabDialogContent"], usesInheritance: true, ngImport: i0, template: `
    <DialogContent
      #reactNode
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [isMultiline]="isMultiline"
      [showCloseButton]="showCloseButton"
      [topButtonsProps]="topButtonsProps"
      [className]="className"
      [subTextId]="subTextId"
      [subText]="subText"
      [titleId]="titleId"
      [title]="title"
      [responsiveMode]="responsiveMode"
      [closeButtonAriaLabel]="closeButtonAriaLabel"
      [type]="type"
      [draggableHeaderClassName]="draggableHeaderClassName"
      (onDismiss)="onDismiss.emit($event && $event.nativeEvent)"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </DialogContent>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabDialogContentComponent = __decorate([
    AngularReact(),
    Styled('FabDialogContentComponent')
], FabDialogContentComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-dialog-content',
                    exportAs: 'fabDialogContent',
                    template: `
    <DialogContent
      #reactNode
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [isMultiline]="isMultiline"
      [showCloseButton]="showCloseButton"
      [topButtonsProps]="topButtonsProps"
      [className]="className"
      [subTextId]="subTextId"
      [subText]="subText"
      [titleId]="titleId"
      [title]="title"
      [responsiveMode]="responsiveMode"
      [closeButtonAriaLabel]="closeButtonAriaLabel"
      [type]="type"
      [draggableHeaderClassName]="draggableHeaderClassName"
      (onDismiss)="onDismiss.emit($event && $event.nativeEvent)"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </DialogContent>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], componentRef: [{
                type: Input
            }], styles: [{
                type: Input
            }], theme: [{
                type: Input
            }], isMultiline: [{
                type: Input
            }], showCloseButton: [{
                type: Input
            }], topButtonsProps: [{
                type: Input
            }], className: [{
                type: Input
            }], subTextId: [{
                type: Input
            }], subText: [{
                type: Input
            }], titleId: [{
                type: Input
            }], title: [{
                type: Input
            }], responsiveMode: [{
                type: Input
            }], closeButtonAriaLabel: [{
                type: Input
            }], type: [{
                type: Input
            }], draggableHeaderClassName: [{
                type: Input
            }], onDismiss: [{
                type: Output
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
const components = [FabDialogComponent, FabDialogContentComponent, FabDialogFooterComponent];
class FabDialogModule {
    constructor() {
        // Add any React elements to the registry (used by the renderer).
        registerElement('Dialog', () => Dialog);
        registerElement('DialogContent', () => DialogContent);
        registerElement('DialogFooter', () => DialogFooter);
    }
}
/** @nocollapse */ FabDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogModule, declarations: [FabDialogComponent, FabDialogContentComponent, FabDialogFooterComponent], imports: [CommonModule], exports: [FabDialogComponent, FabDialogContentComponent, FabDialogFooterComponent] });
/** @nocollapse */ FabDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: components,
                    exports: components,
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

// Copyright (c) Microsoft Corporation. All rights reserved.

/**
 * Generated bundle index. Do not edit.
 */

export { FabDialogComponent, FabDialogContentComponent, FabDialogFooterComponent, FabDialogModule };
